import Location from 'yoda-core-components/lib/helpers/Location/Location';
import get from 'lodash/get';
import RestClient from '../RestClient/RestClient';
import VendorApiConstants from '../Vendor/VendorApiConstants';

const { GOOGLE_API_KEY } = VendorApiConstants;
const loadZipCode = (coords) => {
    const url = VendorApiConstants.GET_LAT_LONG;
    const params = {
        sensor: true,
    };

    if (coords.location.lat && coords.location.lng) {
        params.latlng = `${coords.location.lat},${coords.location.lng}`;
    } else {
        return Promise.reject(new Error('no lat long found'));
    }

    if (GOOGLE_API_KEY) {
        params.key = GOOGLE_API_KEY;
    }

    return RestClient.get({ url, params, external: true })
        .then(({ data }) => {
            try {
                const zipcode = data.results[0].formatted_address.match(/(\d{5})|(\d{5}-\d{4})/);
                return zipcode[0] || zipcode[1];
            } catch (e) {
                throw new Error(e);
            }
        })
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};

const getCoords = async () => new Promise((resolve, reject) => { // eslint-disable-line
        Location.getLatLong(
            (position) => {
                const pos = {
                    location: {
                        lat: get(position, 'coords.latitude'),
                        lng: get(position, 'coords.longitude'),
                    },
                };
                loadZipCode(pos).then(resolve);
            },
            () => null
        );
    });

export const getGeoZipcode = async () => {
    const coords = await getCoords();
    return coords;
};
